import React from "react";
import ReactDOM from "react-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import App from "./App";

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './style.css';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
        <meta
          property="og:title"
          content="Alfa Prima - Sistem Informasi Dosen"
        />
        <meta
          name="description"
          content="Sistem Informasi Dosen - Alfa Prima"
        />
      </Helmet>
      <Helmet>
        <body className="bg-light" />
      </Helmet>
    </HelmetProvider>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
